import { first, get, isEmpty } from 'lodash';

export const toSupplierFormValue = (supplier) => {
  if (isEmpty(supplier)) return null;
  const contactPersonPhone = { code: '', phone: '' };
  if (!supplier.contactPersonPhone) {
    const code = get(supplier.phoneObj, 'code', '+86');
    const phone = get(supplier.phoneObj, 'number', '');

    contactPersonPhone.code = code || '+86';
    contactPersonPhone.phone = phone || get(supplier, 'phoneNumber', '');
  }
  let contactPersonEmail = '';
  if (!supplier.contactPersonEmail) {
    const supplierEmails = get(supplier, 'supplierEmails', []);
    const email = get(first(supplierEmails), 'email');
    contactPersonEmail = get(supplier, 'email', '');
    contactPersonEmail = contactPersonEmail || email;
  }
  return { ...supplier, contactPersonPhone, contactPersonEmail };
};

export const toFactoryFormValue = (factory) => {
  if (isEmpty(factory)) return null;
  const contactPersonPhone = { code: '', phone: '' };
  if (!factory.contactPersonPhone) {
    const code = get(factory.phoneObj, 'code', '+86');
    const phone = get(factory.phoneObj, 'number', '');

    contactPersonPhone.code = code ? `+${code.replace(/\+/g, '')}` : '+86';
    contactPersonPhone.phone = phone || get(factory, 'contactNumber', '');
  }

  let contactPersonEmail = '';
  if (!factory.contactPersonEmail) {
    // contactEmails
    const contactEmails = get(factory, 'contactEmails', []);
    const email = get(first(contactEmails), 'email');
    contactPersonEmail = get(factory, 'email', '');
    contactPersonEmail = contactPersonEmail || email;
  }
  const { factoryCertifications } = factory;

  return {
    ...factory,
    // Tags Certifications
    factoryCertifications: (factoryCertifications || [])
      .filter(({ certificationType }) => certificationType && certificationType.id)
      .map(({ certificationType }) => ({
        id: certificationType.id,
        name: certificationType.name
      })),
    contactPersonPhone,
    contactPersonEmail
  };
};